import { useLang } from '@/i18n';
import css from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { ItfItem } from './type';
import { useEffect, useState } from 'react';
import { arrow } from './icons';
import EcoLink from 'eco-design/base/eco-link';

const K: React.FC = () => {
    const { t } = useLang('ces2026.K');
    const [idx, setIdx] = useState(0);
    const items: ItfItem[] = [
        {
            name: t('item1_name'),
            text: t('item1_text'),
            title: t('item1_title'),
            desc: t('item1_desc'),
            url: t('item1_url'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1765432735988/K1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1765432735989/K1_pad.jpg'],
        },
        {
            name: t('item2_name'),
            text: t('item2_text'),
            title: t('item2_title'),
            desc: t('item2_desc'),
            url: t('item2_url'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1765432735990/K2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1765432735990/K2_pad.jpg'],
        },
        {
            name: t('item3_name'),
            text: t('item3_text'),
            title: t('item3_title'),
            desc: t('item3_desc'),
            url: t('item3_url'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1765432735990/K3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1765432735989/K3_pad.jpg'],
        },
    ];

    const handle_GTM_23 = (item: ItfItem, i: number) => ({
        event: 'uaEvent',
        event_name: 'select_banner',
        banner_name: item.name,
        position: `banner_${i + 1}`,
        button_name: t('btn'),
        __btn_id1: 'ces-2026-K',
        __btn_id2: item.url,
        __btn_type: 'href',
    });

    return (
        <div id="ces-2026-K" className={`ces-2026-K ${css.section} GtmModuleData-section`} data-section-id={'ces-2026-K'}>
            <div className="box">
                <ul className="items">
                    {items.map((item: ItfItem, i: number) => (
                        <li className={`item ${i === idx ? 'active' : 'none'}`} key={i}>
                            <div className="item-img">
                                <EcoImg pc={item.img[0]} />
                            </div>
                            <div className="item-info">
                                <h3 className="item-title title">{item.title}</h3>
                                <p className="item-desc desc">{item.desc}</p>
                            </div>
                        </li>
                    ))}
                </ul>
                <ul className="panels">
                    {items.map((item: ItfItem, i: number) => (
                        <li className={`panel ${i === idx ? 'active' : 'none'}`} key={i}>
                            <div className="panel-header" onClick={() => setIdx(i)}>
                                <h3 className="panel-name name">{item.name}</h3>
                                <span className="panel-arrow">{arrow}</span>
                            </div>
                            <div className="panel-content">
                                <div className="panel-img">
                                    <EcoImg pc={item.img[0]} pad={item.img[1]} />
                                    <div className="panel-info">
                                        <p className="panel-title title">{item.title}</p>
                                        <p className="panel-desc desc">{item.desc}</p>
                                    </div>
                                </div>
                                <p className="panel-text text">{item.text}</p>
                                <EcoLink className="panel-btn GtmModuleData-btn-href" href={item.url} target="_blank" dataLayer={handle_GTM_23(item, i)}>
                                    {t('btn')}
                                </EcoLink>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default K;
